const BitCoinIcon = () => {
  return (
    <svg
      width="9"
      height="12"
      viewBox="0 0 9 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={{flexShrink: 0}}
    >
      <path
        d="M2.10938 9.27083L2.10938 2.60417M4.0625 2.60417V0.9375M4.0625 10.9375V9.27083M2.10938 5.9375H6.01562M6.01562 5.9375C6.66283 5.9375 7.1875 6.49714 7.1875 7.1875V8.02083C7.1875 8.71119 6.66283 9.27083 6.01562 9.27083H0.9375M6.01562 5.9375C6.66283 5.9375 7.1875 5.37786 7.1875 4.6875V3.85417C7.1875 3.16381 6.66283 2.60417 6.01562 2.60417H0.9375"
        stroke="white"
        stroke-width="1.875"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export default BitCoinIcon;
